import axios from "axios";
const Url = process.env.REACT_APP_URl;

export const SaveWatermarkSettings = async (payload: { watermarkLogo?: string, position: string, transparency: number }) => {
    const apiUrl = Url + "/settings";
    const response = await axios.post(apiUrl, payload, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const GetWatermarkSettings = async () => {
    const apiUrl = Url + "/settings";
    const response = await axios.get(apiUrl, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}
